var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultsMobileGe(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4568.89 7034.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:lime;}.cls-2{fill:#ccc;}.cls-3{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grey"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "722.52 1883.57 722.52 1932.95 547.35 1932.95 547.35 572.68 1948.65 572.68 1948.65 659.08 1992.44 659.08 1992.44 702.87 2033.54 702.87 2033.54 1883.57 722.52 1883.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3201.43 1871.35 3201.43 1920.74 2544.57 1920.74 2544.57 560.46 3858.28 560.47 3858.28 778.24 3989.66 778.24 3989.65 822.03 4030.76 822.03 4030.76 1871.35 3201.43 1871.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1912.53 4074.35 1912.53 4113.3 555.02 4113.3 555.02 2803.51 2000.11 2803.51 2000.11 2846.12 2041.21 2846.12 2041.21 4074.35 1912.53 4074.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3252.4 4162.28 3252.4 4203.38 2550.55 4203.38 2550.55 2803.6 3864.27 2803.6 3864.27 2977.57 3908.03 2977.57 3908.03 3021.36 4036.75 3021.36 4036.75 4162.28 3252.4 4162.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1597.91 6361.94 1597.91 6400.9 547.04 6400.9 547.04 5091.1 1904.52 5091.11 1904.52 5177.5 1947.74 5176.91 1948.34 5220.14 2033.23 5220.14 2033.23 6361.94 1597.91 6361.94"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1993.33 608.19 2036.21 608.19 2036.21 651.98 2079.1 651.98 2079.1 521.78 1993.33 521.78 1993.33 608.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2041.21,
    y: 2760.91,
    width: 41.1,
    height: 42.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3917.73 2931.41 3961.49 2931.41 3961.49 2974.02 4090.2 2974.02 4090.2 2757.44 3917.73 2757.44 3917.73 2931.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3916.78 726.17 4048.15 726.17 4048.15 769.96 4089.26 769.96 4089.26 508.4 3916.78 508.4 3916.78 726.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2000.02 5174.54 2000.02 5130.15 1956.23 5130.15 1956.23 5044.34 2084.92 5044.34 2084.92 5174.54 2000.02 5174.54"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1992.44,
    y1: 659.08,
    x2: 1992.44,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1948.65,
    y1: 572.68,
    x2: 1948.65,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1904.86,
    y1: 572.68,
    x2: 1904.86,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1861.07,
    y1: 572.68,
    x2: 1861.07,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1817.28,
    y1: 572.68,
    x2: 1817.28,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1773.49,
    y1: 572.68,
    x2: 1773.49,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1729.7,
    y1: 572.68,
    x2: 1729.7,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1685.91,
    y1: 572.68,
    x2: 1685.91,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1642.11,
    y1: 572.68,
    x2: 1642.12,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1598.32,
    y1: 572.68,
    x2: 1598.33,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1554.53,
    y1: 572.68,
    x2: 1554.54,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1510.74,
    y1: 572.68,
    x2: 1510.75,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1466.95,
    y1: 572.68,
    x2: 1466.96,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1423.16,
    y1: 572.68,
    x2: 1423.17,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1379.37,
    y1: 572.68,
    x2: 1379.37,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1335.58,
    y1: 572.68,
    x2: 1335.58,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1291.79,
    y1: 572.68,
    x2: 1291.79,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1248,
    y1: 572.68,
    x2: 1248,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1204.21,
    y1: 572.68,
    x2: 1204.21,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1160.42,
    y1: 572.68,
    x2: 1160.42,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1116.63,
    y1: 572.68,
    x2: 1116.63,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1072.84,
    y1: 572.68,
    x2: 1072.84,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1029.05,
    y1: 572.68,
    x2: 1029.05,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 985.26,
    y1: 572.68,
    x2: 985.26,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 941.47,
    y1: 572.68,
    x2: 941.47,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 897.68,
    y1: 572.68,
    x2: 897.68,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 853.89,
    y1: 572.68,
    x2: 853.89,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 810.09,
    y1: 572.68,
    x2: 810.1,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 766.3,
    y1: 572.68,
    x2: 766.31,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 722.51,
    y1: 572.68,
    x2: 722.52,
    y2: 1882.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 678.72,
    y1: 572.68,
    x2: 678.73,
    y2: 1932.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634.93,
    y1: 572.68,
    x2: 634.94,
    y2: 1932.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 591.14,
    y1: 572.68,
    x2: 591.15,
    y2: 1932.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 615.29,
    x2: 1948.65,
    y2: 615.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 659.08,
    x2: 2033.54,
    y2: 659.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 702.87,
    x2: 2033.54,
    y2: 702.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 746.66,
    x2: 2033.54,
    y2: 746.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 790.45,
    x2: 2033.54,
    y2: 790.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 834.24,
    x2: 2033.54,
    y2: 834.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 878.03,
    x2: 2033.54,
    y2: 878.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 921.83,
    x2: 2033.54,
    y2: 921.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 965.62,
    x2: 2033.54,
    y2: 965.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1009.41,
    x2: 2033.54,
    y2: 1009.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1053.2,
    x2: 2033.54,
    y2: 1053.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1096.99,
    x2: 2033.54,
    y2: 1096.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1140.78,
    x2: 2033.54,
    y2: 1140.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1184.57,
    x2: 2033.54,
    y2: 1184.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1228.36,
    x2: 2033.54,
    y2: 1228.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1272.15,
    x2: 2033.54,
    y2: 1272.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1315.94,
    x2: 2033.54,
    y2: 1315.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1359.73,
    x2: 2033.54,
    y2: 1359.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1403.52,
    x2: 2033.54,
    y2: 1403.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1447.31,
    x2: 2033.54,
    y2: 1447.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1491.1,
    x2: 2033.54,
    y2: 1491.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1534.89,
    x2: 2033.54,
    y2: 1534.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1578.68,
    x2: 2033.54,
    y2: 1578.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1622.47,
    x2: 2033.54,
    y2: 1622.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1666.26,
    x2: 2033.54,
    y2: 1666.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1710.05,
    x2: 2033.54,
    y2: 1710.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1753.85,
    x2: 2033.54,
    y2: 1753.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1797.64,
    x2: 2033.54,
    y2: 1797.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1841.43,
    x2: 2033.54,
    y2: 1841.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.35,
    y1: 1885.22,
    x2: 2033.54,
    y2: 1885.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1992.44,
    y1: 564.63,
    x2: 2079.1,
    y2: 564.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2036.23,
    y1: 521.3,
    x2: 2036.23,
    y2: 607.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1992.88,
    y1: 607.4,
    x2: 2079.54,
    y2: 607.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3989.65,
    y1: 778.24,
    x2: 3989.66,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3945.86,
    y1: 778.24,
    x2: 3945.87,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3902.07,
    y1: 778.24,
    x2: 3902.08,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3858.28,
    y1: 560.47,
    x2: 3858.29,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3814.49,
    y1: 560.47,
    x2: 3814.5,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3770.7,
    y1: 560.47,
    x2: 3770.7,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3726.91,
    y1: 560.47,
    x2: 3726.91,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3683.12,
    y1: 560.47,
    x2: 3683.12,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3639.33,
    y1: 560.47,
    x2: 3639.33,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3595.54,
    y1: 560.47,
    x2: 3595.54,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3551.75,
    y1: 560.47,
    x2: 3551.75,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3507.96,
    y1: 560.47,
    x2: 3507.96,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3464.17,
    y1: 560.47,
    x2: 3464.17,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3420.38,
    y1: 560.47,
    x2: 3420.38,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3376.59,
    y1: 560.47,
    x2: 3376.59,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3332.8,
    y1: 560.47,
    x2: 3332.8,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3289.01,
    y1: 560.47,
    x2: 3289.01,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3245.22,
    y1: 560.47,
    x2: 3245.22,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3201.42,
    y1: 560.47,
    x2: 3201.43,
    y2: 1870.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3157.63,
    y1: 560.47,
    x2: 3157.64,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3113.84,
    y1: 560.47,
    x2: 3113.85,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3070.05,
    y1: 560.47,
    x2: 3070.06,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3026.26,
    y1: 560.47,
    x2: 3026.27,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2982.47,
    y1: 560.47,
    x2: 2982.48,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2938.68,
    y1: 560.47,
    x2: 2938.68,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2894.89,
    y1: 560.47,
    x2: 2894.89,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2851.1,
    y1: 560.47,
    x2: 2851.1,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2807.31,
    y1: 560.47,
    x2: 2807.31,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2763.52,
    y1: 560.47,
    x2: 2763.52,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2719.73,
    y1: 560.47,
    x2: 2719.73,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2675.94,
    y1: 560.47,
    x2: 2675.94,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2632.15,
    y1: 560.47,
    x2: 2632.15,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2588.36,
    y1: 560.47,
    x2: 2588.36,
    y2: 1920.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 603.07,
    x2: 3861.64,
    y2: 603.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 646.87,
    x2: 3858.28,
    y2: 646.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 690.66,
    x2: 3858.28,
    y2: 690.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 734.45,
    x2: 3858.28,
    y2: 734.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 778.24,
    x2: 3989.66,
    y2: 778.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 822.03,
    x2: 4030.76,
    y2: 822.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 865.82,
    x2: 4030.76,
    y2: 865.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 909.61,
    x2: 4030.76,
    y2: 909.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 953.4,
    x2: 4030.76,
    y2: 953.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 997.19,
    x2: 4030.76,
    y2: 997.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1040.98,
    x2: 4030.76,
    y2: 1040.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1084.77,
    x2: 4030.76,
    y2: 1084.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1128.56,
    x2: 4030.76,
    y2: 1128.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1172.35,
    x2: 4030.76,
    y2: 1172.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1216.14,
    x2: 4030.76,
    y2: 1216.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1259.93,
    x2: 4030.76,
    y2: 1259.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1303.72,
    x2: 4030.76,
    y2: 1303.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1347.51,
    x2: 4030.76,
    y2: 1347.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1391.3,
    x2: 4030.76,
    y2: 1391.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1435.1,
    x2: 4030.76,
    y2: 1435.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1478.89,
    x2: 4030.76,
    y2: 1478.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1522.68,
    x2: 4030.76,
    y2: 1522.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1566.47,
    x2: 4030.76,
    y2: 1566.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1610.26,
    x2: 4030.76,
    y2: 1610.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1654.05,
    x2: 4030.76,
    y2: 1654.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1697.84,
    x2: 4030.76,
    y2: 1697.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1741.63,
    x2: 4030.76,
    y2: 1741.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1785.42,
    x2: 4030.76,
    y2: 1785.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1829.21,
    x2: 4030.76,
    y2: 1829.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2544.57,
    y1: 1873,
    x2: 4030.76,
    y2: 1873
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3913.91,
    y1: 551.73,
    x2: 4089.56,
    y2: 551.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3960.57,
    y1: 508.4,
    x2: 3960.57,
    y2: 726.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4003.02,
    y1: 508.4,
    x2: 4003.02,
    y2: 726.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4045.83,
    y1: 508.4,
    x2: 4045.83,
    y2: 726.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3914.35,
    y1: 594.5,
    x2: 4089.26,
    y2: 594.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3913.91,
    y1: 639.18,
    x2: 4088.82,
    y2: 639.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3914.79,
    y1: 683.14,
    x2: 4089.7,
    y2: 683.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3916.28,
    y1: 727.09,
    x2: 4091.19,
    y2: 727.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2000.11,
    y1: 2846.12,
    x2: 2000.11,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1956.32,
    y1: 2803.51,
    x2: 1956.32,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1912.53,
    y1: 2803.51,
    x2: 1912.53,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1868.74,
    y1: 2803.51,
    x2: 1868.74,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1824.95,
    y1: 2803.51,
    x2: 1824.95,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1781.16,
    y1: 2803.51,
    x2: 1781.16,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1737.36,
    y1: 2803.51,
    x2: 1737.37,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1693.57,
    y1: 2803.51,
    x2: 1693.58,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1649.78,
    y1: 2803.51,
    x2: 1649.79,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1605.99,
    y1: 2803.51,
    x2: 1606,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1562.2,
    y1: 2803.51,
    x2: 1562.21,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1518.41,
    y1: 2803.51,
    x2: 1518.41,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1474.62,
    y1: 2803.51,
    x2: 1474.62,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1430.83,
    y1: 2803.51,
    x2: 1430.83,
    y2: 4113.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1387.04,
    y1: 2803.51,
    x2: 1387.04,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1343.25,
    y1: 2803.51,
    x2: 1343.25,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1299.46,
    y1: 2803.51,
    x2: 1299.46,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1255.67,
    y1: 2803.51,
    x2: 1255.67,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1211.88,
    y1: 2803.51,
    x2: 1211.88,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1168.09,
    y1: 2803.51,
    x2: 1168.09,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1124.3,
    y1: 2803.51,
    x2: 1124.3,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1080.51,
    y1: 2803.51,
    x2: 1080.51,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1036.72,
    y1: 2803.51,
    x2: 1036.72,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 992.93,
    y1: 2803.51,
    x2: 992.93,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 949.13,
    y1: 2803.51,
    x2: 949.14,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 905.34,
    y1: 2803.51,
    x2: 905.35,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 861.55,
    y1: 2803.51,
    x2: 861.56,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 817.76,
    y1: 2803.51,
    x2: 817.77,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 773.97,
    y1: 2803.51,
    x2: 773.98,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 730.18,
    y1: 2803.51,
    x2: 730.19,
    y2: 4113.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 686.39,
    y1: 2803.51,
    x2: 686.39,
    y2: 4163.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 642.6,
    y1: 2803.51,
    x2: 642.6,
    y2: 4163.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 598.81,
    y1: 2803.51,
    x2: 598.81,
    y2: 4163.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 2846.12,
    x2: 2000.11,
    y2: 2846.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 2889.91,
    x2: 2041.21,
    y2: 2889.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 2933.7,
    x2: 2041.21,
    y2: 2933.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 2977.49,
    x2: 2041.21,
    y2: 2977.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3021.28,
    x2: 2041.21,
    y2: 3021.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3065.07,
    x2: 2041.21,
    y2: 3065.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3108.86,
    x2: 2041.21,
    y2: 3108.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3152.65,
    x2: 2041.21,
    y2: 3152.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3196.44,
    x2: 2041.21,
    y2: 3196.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3240.23,
    x2: 2041.21,
    y2: 3240.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3284.02,
    x2: 2041.21,
    y2: 3284.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3327.82,
    x2: 2041.21,
    y2: 3327.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3371.61,
    x2: 2041.21,
    y2: 3371.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3415.4,
    x2: 2041.21,
    y2: 3415.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3459.19,
    x2: 2041.21,
    y2: 3459.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3502.98,
    x2: 2041.21,
    y2: 3502.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3546.77,
    x2: 2041.21,
    y2: 3546.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3590.56,
    x2: 2041.21,
    y2: 3590.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3634.35,
    x2: 2041.21,
    y2: 3634.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3678.14,
    x2: 2041.21,
    y2: 3678.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3721.93,
    x2: 2041.21,
    y2: 3721.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3765.72,
    x2: 2041.21,
    y2: 3765.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3809.51,
    x2: 2041.21,
    y2: 3809.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3853.3,
    x2: 2041.21,
    y2: 3853.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3897.09,
    x2: 2041.21,
    y2: 3897.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3940.88,
    x2: 2041.21,
    y2: 3940.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 3984.67,
    x2: 2041.21,
    y2: 3984.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 4028.46,
    x2: 2041.21,
    y2: 4028.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.02,
    y1: 4072.25,
    x2: 2041.21,
    y2: 4072.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3995.64,
    y1: 3023.45,
    x2: 3995.64,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3951.85,
    y1: 3023.45,
    x2: 3951.85,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3908.06,
    y1: 3023.45,
    x2: 3908.06,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3864.27,
    y1: 2803.6,
    x2: 3864.27,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3820.48,
    y1: 2803.6,
    x2: 3820.48,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3776.69,
    y1: 2803.6,
    x2: 3776.69,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3732.9,
    y1: 2803.6,
    x2: 3732.9,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3689.11,
    y1: 2803.6,
    x2: 3689.11,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3645.32,
    y1: 2803.6,
    x2: 3645.32,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3601.53,
    y1: 2803.6,
    x2: 3601.53,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3557.74,
    y1: 2803.6,
    x2: 3557.74,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3513.95,
    y1: 2803.6,
    x2: 3513.95,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3470.16,
    y1: 2803.6,
    x2: 3470.16,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3426.36,
    y1: 2803.6,
    x2: 3426.37,
    y2: 4161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3382.57,
    y1: 2803.6,
    x2: 3382.58,
    y2: 4161.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3338.78,
    y1: 2803.6,
    x2: 3338.79,
    y2: 4161.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3294.99,
    y1: 2803.6,
    x2: 3295,
    y2: 4161.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3251.2,
    y1: 2803.6,
    x2: 3251.21,
    y2: 4161.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3207.41,
    y1: 2803.6,
    x2: 3207.42,
    y2: 4205.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3163.62,
    y1: 2803.6,
    x2: 3163.62,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3119.83,
    y1: 2803.6,
    x2: 3119.83,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3076.04,
    y1: 2803.6,
    x2: 3076.04,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3032.25,
    y1: 2803.6,
    x2: 3032.25,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2988.46,
    y1: 2803.6,
    x2: 2988.46,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2944.67,
    y1: 2803.6,
    x2: 2944.67,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2900.88,
    y1: 2803.6,
    x2: 2900.88,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2857.09,
    y1: 2803.6,
    x2: 2857.09,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2813.3,
    y1: 2803.6,
    x2: 2813.3,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2769.51,
    y1: 2803.6,
    x2: 2769.51,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2725.72,
    y1: 2803.6,
    x2: 2725.72,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2681.93,
    y1: 2803.6,
    x2: 2681.93,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2638.14,
    y1: 2803.6,
    x2: 2638.14,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2594.34,
    y1: 2803.6,
    x2: 2594.35,
    y2: 4217.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 2846.21,
    x2: 3867.63,
    y2: 2846.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 2890,
    x2: 3864.27,
    y2: 2890
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 2933.79,
    x2: 3864.27,
    y2: 2933.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 2977.58,
    x2: 3864.27,
    y2: 2977.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3021.37,
    x2: 4041.81,
    y2: 3021.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3065.16,
    x2: 4036.75,
    y2: 3065.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3108.95,
    x2: 4036.75,
    y2: 3108.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3152.74,
    x2: 4036.75,
    y2: 3152.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3196.54,
    x2: 4036.75,
    y2: 3196.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3240.33,
    x2: 4036.75,
    y2: 3240.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3284.12,
    x2: 4036.75,
    y2: 3284.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3327.91,
    x2: 4036.75,
    y2: 3327.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3371.7,
    x2: 4036.75,
    y2: 3371.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3415.49,
    x2: 4036.75,
    y2: 3415.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3459.28,
    x2: 4036.75,
    y2: 3459.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3503.07,
    x2: 4036.75,
    y2: 3503.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3546.86,
    x2: 4036.75,
    y2: 3546.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3590.65,
    x2: 4036.75,
    y2: 3590.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3634.44,
    x2: 4036.75,
    y2: 3634.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3678.23,
    x2: 4036.75,
    y2: 3678.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3722.02,
    x2: 4036.75,
    y2: 3722.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3765.81,
    x2: 4036.75,
    y2: 3765.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3809.6,
    x2: 4036.75,
    y2: 3809.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3853.39,
    x2: 4036.75,
    y2: 3853.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3897.18,
    x2: 4036.75,
    y2: 3897.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3940.97,
    x2: 4036.75,
    y2: 3940.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 3984.77,
    x2: 4036.75,
    y2: 3984.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 4028.56,
    x2: 4036.75,
    y2: 4028.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 4072.35,
    x2: 4036.75,
    y2: 4072.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2550.56,
    y1: 4116.14,
    x2: 4036.74,
    y2: 4116.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2551.9,
    y1: 4161.51,
    x2: 4036.75,
    y2: 4161.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3914.85,
    y1: 2800.77,
    x2: 4090.51,
    y2: 2800.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3961.52,
    y1: 2757.44,
    x2: 3961.52,
    y2: 2975.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4003.96,
    y1: 2757.44,
    x2: 4003.96,
    y2: 2975.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4046.77,
    y1: 2757.44,
    x2: 4046.77,
    y2: 2975.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3915.29,
    y1: 2843.54,
    x2: 4090.2,
    y2: 2843.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3914.85,
    y1: 2888.22,
    x2: 4089.76,
    y2: 2888.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3915.73,
    y1: 2932.18,
    x2: 4090.64,
    y2: 2932.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1992.13,
    y1: 5221.29,
    x2: 1992.13,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1948.33,
    y1: 5177.5,
    x2: 1948.34,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1904.54,
    y1: 5091.11,
    x2: 1904.55,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1860.75,
    y1: 5091.11,
    x2: 1860.76,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1816.96,
    y1: 5091.11,
    x2: 1816.97,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1773.17,
    y1: 5091.11,
    x2: 1773.18,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1729.38,
    y1: 5091.11,
    x2: 1729.39,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1685.59,
    y1: 5091.11,
    x2: 1685.59,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1641.8,
    y1: 5091.11,
    x2: 1641.8,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1598.01,
    y1: 5091.11,
    x2: 1598.01,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1554.22,
    y1: 5091.11,
    x2: 1554.22,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1510.43,
    y1: 5091.11,
    x2: 1510.43,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1466.64,
    y1: 5091.11,
    x2: 1466.64,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1422.85,
    y1: 5091.11,
    x2: 1422.85,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1379.06,
    y1: 5091.11,
    x2: 1379.06,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1335.27,
    y1: 5091.11,
    x2: 1335.27,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1291.48,
    y1: 5091.11,
    x2: 1291.48,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1247.69,
    y1: 5091.11,
    x2: 1247.69,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1203.9,
    y1: 5091.11,
    x2: 1203.9,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1160.11,
    y1: 5091.11,
    x2: 1160.11,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1116.31,
    y1: 5091.11,
    x2: 1116.32,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1072.52,
    y1: 5091.11,
    x2: 1072.53,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1028.73,
    y1: 5091.11,
    x2: 1028.74,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 984.94,
    y1: 5091.11,
    x2: 984.95,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 941.15,
    y1: 5091.11,
    x2: 941.16,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 897.36,
    y1: 5091.11,
    x2: 897.37,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 853.57,
    y1: 5091.11,
    x2: 853.57,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 809.78,
    y1: 5091.11,
    x2: 809.78,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 765.99,
    y1: 5091.11,
    x2: 765.99,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 722.2,
    y1: 5091.11,
    x2: 722.2,
    y2: 6400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 678.41,
    y1: 5091.11,
    x2: 678.41,
    y2: 6451.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634.62,
    y1: 5091.11,
    x2: 634.62,
    y2: 6451.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 590.83,
    y1: 5091.11,
    x2: 590.83,
    y2: 6451.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5133.71,
    x2: 1909.58,
    y2: 5133.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5177.5,
    x2: 1948.33,
    y2: 5177.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5221.29,
    x2: 2033.23,
    y2: 5221.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5265.08,
    x2: 2033.23,
    y2: 5265.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5308.87,
    x2: 2033.23,
    y2: 5308.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5352.66,
    x2: 2033.23,
    y2: 5352.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5396.45,
    x2: 2033.23,
    y2: 5396.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5440.25,
    x2: 2033.23,
    y2: 5440.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5484.04,
    x2: 2033.23,
    y2: 5484.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5527.83,
    x2: 2033.23,
    y2: 5527.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5571.62,
    x2: 2033.23,
    y2: 5571.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5615.41,
    x2: 2033.23,
    y2: 5615.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5659.2,
    x2: 2033.23,
    y2: 5659.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5702.99,
    x2: 2033.23,
    y2: 5702.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5746.78,
    x2: 2033.23,
    y2: 5746.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5790.57,
    x2: 2033.23,
    y2: 5790.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5834.36,
    x2: 2033.23,
    y2: 5834.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5878.15,
    x2: 2033.23,
    y2: 5878.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5921.94,
    x2: 2033.23,
    y2: 5921.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 5965.73,
    x2: 2033.23,
    y2: 5965.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 6009.52,
    x2: 2033.23,
    y2: 6009.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 6053.31,
    x2: 2033.23,
    y2: 6053.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 6097.1,
    x2: 2033.23,
    y2: 6097.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 6140.89,
    x2: 2033.23,
    y2: 6140.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 6184.68,
    x2: 2033.23,
    y2: 6184.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 6228.48,
    x2: 2033.23,
    y2: 6228.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 6272.27,
    x2: 2033.23,
    y2: 6272.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 6316.06,
    x2: 2033.23,
    y2: 6316.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.04,
    y1: 6359.85,
    x2: 2033.23,
    y2: 6359.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2000.02,
    y1: 5174.54,
    x2: 2000.02,
    y2: 5044.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2044.3,
    y1: 5174.54,
    x2: 2044.3,
    y2: 5044.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1955.48,
    y1: 5129.66,
    x2: 2085.67,
    y2: 5129.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1955.48,
    y1: 5086.88,
    x2: 2085.67,
    y2: 5086.88
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsMobileGe);
export default __webpack_public_path__ + "static/media/results-mobile-ge.207ca77da08fc8879887f40134ad99c7.svg";
export { ForwardRef as ReactComponent };